import { useEffect } from 'react';
import { setDevice } from '../redux/sequence/sequence-slice';
import store from '../redux/store';
import { getDeviceForWidth } from '../styles/breakpoints';

const syncDevice = () => {
  const newDevice = getDeviceForWidth(window.innerWidth);
  // Only dispatch when the device tier actually changes
  if (newDevice !== store.getState().sequence.device) {
    store.dispatch(setDevice(newDevice));
  }
};

const useDeviceBreakpoint = () => {
  useEffect(() => {
    syncDevice();
    window.addEventListener('resize', syncDevice);
    return () => window.removeEventListener('resize', syncDevice);
  }, []);
};

export default useDeviceBreakpoint;
